export const responseFormat = {
  JSON: 'json',
  XML: 'xml'
};
